import {Fragment, useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {EmailInputWithVerification, EmailVerificationResponse} from "@pg-rp/email-with-verification";

import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";

interface Props {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disablePhone?: boolean;
    smsLoginErrorMessage?: string | null;
}

const SMS_LOGIN_ERROR_BOLD_PARTS = ["Popraw numer, aby kontynuować,", "adres e-mail, by założyć nowe konto."];

export const LeadFormUserDataFields = (props: Props) => {
    const {verificationTrigger, verificationData, disablePhone, smsLoginErrorMessage} = props;
    const codes = useAppSelector((state) => state.variables.data?.country_codes);
    const {data: userProfile} = useGetUserProfileQuery();
    const {watch, getValues} = useFormContext();
    const [isSmsLoginErrorHidden, setIsSmsLoginErrorHidden] = useState(false);
    const shouldShowSmsLoginError = Boolean(smsLoginErrorMessage && !isSmsLoginErrorHidden);

    useEffect(() => {
        setIsSmsLoginErrorHidden(false);
    }, [smsLoginErrorMessage]);

    useEffect(() => {
        if (!smsLoginErrorMessage) {
            return undefined;
        }

        // Snapshot the email/phone present when the error appeared so we only hide it on a real user edit.
        // watch() also fires on programmatic same-value writes (the email verification hook calls
        // setValue("email", ...) on a debounce), which would otherwise hide the error without any user action.
        const {email: emailAtError, phone: phoneAtError} = getValues();
        const phoneAtErrorKey = JSON.stringify(phoneAtError);

        const subscription = watch((values, {name}) => {
            if (name !== "email" && name !== "phone" && !name?.startsWith("phone.")) {
                return;
            }

            const emailEdited = values.email !== emailAtError;
            const phoneEdited = JSON.stringify(values.phone) !== phoneAtErrorKey;

            if (emailEdited || phoneEdited) {
                setIsSmsLoginErrorHidden(true);
            }
        });

        return () => subscription.unsubscribe();
    }, [smsLoginErrorMessage, watch, getValues]);

    const renderSmsLoginErrorMessage = () => {
        if (!smsLoginErrorMessage) {
            return null;
        }

        let parts = [smsLoginErrorMessage];

        for (const boldPart of SMS_LOGIN_ERROR_BOLD_PARTS) {
            parts = parts.flatMap((part) =>
                part === boldPart ? [part] : part.split(boldPart).flatMap((messagePart, index) => (index === 0 ? [messagePart] : [boldPart, messagePart]))
            );
        }

        return (
            <Text as="div" variant="info_txt_1" className={smsLoginErrorStyle}>
                {parts.map((part, index) => {
                    if (!part) {
                        return null;
                    }

                    if (SMS_LOGIN_ERROR_BOLD_PARTS.includes(part)) {
                        return <strong key={`${part}-${index}`}>{part}</strong>;
                    }

                    return <Fragment key={`${part}-${index}`}>{part}</Fragment>;
                })}
            </Text>
        );
    };

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <EmailInputWithVerification
                verificationData={verificationData}
                verificationTrigger={verificationTrigger}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT}
            />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
                disabled={disablePhone ?? !!userProfile?.phone}
                fieldState={shouldShowSmsLoginError ? "error" : undefined}
                afterInput={shouldShowSmsLoginError ? renderSmsLoginErrorMessage() : undefined}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const smsLoginErrorStyle = css({
    mt: 1,
    p: 1,
    borderRadius: 1,
    color: "var(--colors-white)",
    backgroundColor: "var(--colors-gray-800)"
});
import {Fragment, useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {EmailInputWithVerification, EmailVerificationResponse} from "@pg-rp/email-with-verification";

import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";

interface Props {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disablePhone?: boolean;
    smsLoginErrorMessage?: string | null;
}

const SMS_LOGIN_ERROR_BOLD_PARTS = ["Popraw numer, aby kontynuować,", "adres e-mail, by założyć nowe konto."];

export const LeadFormUserDataFields = (props: Props) => {
    const {verificationTrigger, verificationData, disablePhone, smsLoginErrorMessage} = props;
    const codes = useAppSelector((state) => state.variables.data?.country_codes);
    const {data: userProfile} = useGetUserProfileQuery();
    const {watch, getValues} = useFormContext();
    const [isSmsLoginErrorHidden, setIsSmsLoginErrorHidden] = useState(false);
    const shouldShowSmsLoginError = Boolean(smsLoginErrorMessage && !isSmsLoginErrorHidden);

    useEffect(() => {
        setIsSmsLoginErrorHidden(false);
    }, [smsLoginErrorMessage]);

    useEffect(() => {
        if (!smsLoginErrorMessage) {
            return undefined;
        }

        // Snapshot the email/phone present when the error appeared so we only hide it on a real user edit.
        // watch() also fires on programmatic same-value writes (the email verification hook calls
        // setValue("email", ...) on a debounce), which would otherwise hide the error without any user action.
        const {email: emailAtError, phone: phoneAtError} = getValues();
        const phoneAtErrorKey = JSON.stringify(phoneAtError);

        const subscription = watch((values, {name}) => {
            if (name !== "email" && name !== "phone" && !name?.startsWith("phone.")) {
                return;
            }

            const emailEdited = values.email !== emailAtError;
            const phoneEdited = JSON.stringify(values.phone) !== phoneAtErrorKey;

            if (emailEdited || phoneEdited) {
                setIsSmsLoginErrorHidden(true);
            }
        });

        return () => subscription.unsubscribe();
    }, [smsLoginErrorMessage, watch, getValues]);

    const renderSmsLoginErrorMessage = () => {
        if (!smsLoginErrorMessage) {
            return null;
        }

        let parts = [smsLoginErrorMessage];

        for (const boldPart of SMS_LOGIN_ERROR_BOLD_PARTS) {
            parts = parts.flatMap((part) =>
                part === boldPart ? [part] : part.split(boldPart).flatMap((messagePart, index) => (index === 0 ? [messagePart] : [boldPart, messagePart]))
            );
        }

        return (
            <Text as="div" variant="info_txt_1" className={smsLoginErrorStyle}>
                {parts.map((part, index) => {
                    if (!part) {
                        return null;
                    }

                    if (SMS_LOGIN_ERROR_BOLD_PARTS.includes(part)) {
                        return <strong key={`${part}-${index}`}>{part}</strong>;
                    }

                    return <Fragment key={`${part}-${index}`}>{part}</Fragment>;
                })}
            </Text>
        );
    };

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <EmailInputWithVerification
                verificationData={verificationData}
                verificationTrigger={verificationTrigger}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT}
            />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
                disabled={disablePhone ?? !!userProfile?.phone}
                fieldState={shouldShowSmsLoginError ? "error" : undefined}
                afterInput={shouldShowSmsLoginError ? renderSmsLoginErrorMessage() : undefined}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const smsLoginErrorStyle = css({
    mt: 1,
    p: 1,
    borderRadius: 1,
    color: "var(--colors-white)",
    backgroundColor: "var(--colors-gray-800)"
});
